import type { CmpHider } from './types';

export const usercentrics: CmpHider = {
  id: 'usercentrics',
  label: 'Usercentrics',
  css: `
      /* Usercentrics: the consent UI mounts inside a shadow root on a host
         element, so the only thing reachable from this stylesheet is the host
         itself — hiding the host hides the whole shadow banner, backdrop, and
         preferences modal in one go. v3 mounts on the <aside id="usercentrics-cmp-ui">
         host; older v2 builds use #usercentrics-root, and some embeds expose
         #uc-center-container / [data-testid="uc-app"] plus a separate fixed
         overlay ([data-testid="uc-overlay"] / .uc-overlay). Hide them all.
         Usercentrics locks scroll via an inline "overflow: hidden" on <body>
         (and sometimes <html>) rather than a class; the html/body[style*="overflow"]
         release rule above (added for Cookiebot) already out-specifies that inline
         lock, so no extra scroll-lock rule is needed here. */
      #usercentrics-cmp-ui,
      #usercentrics-root,
      #uc-center-container,
      [data-testid="uc-app"],
      [data-testid="uc-overlay"],
      .uc-overlay { display: none !important; }
  `,
};
